module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-2-2-a50de0857b7fbd38c451d46a603ef13d.png";